import SimpleFooter from "./Footer.styled"
import React from "react";

export default function Footer() {
  return (
    <SimpleFooter>
      <p>@ 2021 Ridwan Bin Monjur. All rights reserved</p>
    </SimpleFooter>
  )
}
